/* eslint-disable no-nested-ternary */
export class Maths
{
    public static PI = Math.PI;
    public static PI_HALF = Math.PI * 0.5;
    public static PI_QUART = Math.PI * 0.25;
    public static PI_DOUBLE = Math.PI * 2;

    // https://web.archive.org/web/20090717035140if_/javascript.about.com/od/problemsolving/a/modulobug.htm
    public static mod(a: number, b: number): number
    {
        return ((a % b) + b) % b;
    }

    public static roundNeg(v: number): number
    {
        return Math.round(Math.abs(v)) * (v >= 0 ? 1 : -1);
    }

    public static floorNeg(v: number): number
    {
        return Math.floor(Math.abs(v)) * (v >= 0 ? 1 : -1);
    }

    public static ceilNeg(v: number): number
    {
        return Math.ceil(Math.abs(v)) * (v >= 0 ? 1 : -1);
    }

    public static lerp(a: number, b: number, t: number): number
    {
        return a + ((b - a) * (t < 0 ? 0 : t > 1 ? 1 : t));
    }

    public static lerpMaxStep(a: number, b: number, t: number, s: number): number
    {
        const step = ((b - a) * (t < 0 ? 0 : t > 1 ? 1 : t));

        return a + Maths.clamp(step, -s, s);
    }

    public static tween(a: number, b: number, t: number): number
    {
        return a + ((b - a) * t);
    }

    public static distance(ax: number, ay: number, bx = 0, by = 0): number
    {
        const dx = bx - ax;
        const dy = by - ay;

        return Math.sqrt((dx * dx) + (dy * dy));
    }

    public static sign(v: number): number
    {
        return v < 0 ? -1 : v > 0 ? 1 : 0;
    }

    public static signNon0(v: number): number
    {
        return v < 0 ? -1 : 1;
    }

    public static clamp(v: number, min = 0, max = 1): number
    {
        if (min > max) [min, max] = [max, min];

        return v < min ? min : v > max ? max : v;
    }

    public static angleDifference(angle1: number, angle2: number): number
    {
        const diff = ((angle2 - angle1 + Math.PI) % Maths.PI_DOUBLE) - Math.PI;

        return diff < -Math.PI ? diff + Maths.PI_DOUBLE : diff;
    }

    public static toFixed(v: number, fractionDigits = 2): number
    {
        return Number(v.toFixed(fractionDigits));
    }

    public static rotatePoint(p: {x: number, y: number}, r: number, cx = 0, cy = 0): {x: number, y: number}
    {
        const s = Math.sin(r);
        const c = Math.cos(r);

        p.x -= cx;
        p.y -= cy;

        const px = (p.x * c) - (p.y * s);
        const py = (p.x * s) + (p.y * c);

        p.x = px + cx;
        p.y = py + cy;

        return p;
    }
}

